var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-form-group',{attrs:{"label":_vm.label}},[_c('o-timepicker-control',{model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }